import { API_URL, imagePath } from "constants/constants"
import React, { useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Row,
  CardTitle,
  ModalHeader,
  ModalBody,
  Modal,
} from "reactstrap"
import { hasPermission } from "helpers/helpers"
import axios from "axios"
export default function SecurityDetails(props) {
  const { userData } = props
  const [modalOpen, setModalOpen] = useState(false)
  const [imageUrl, setImageUrl] = useState("")

  const toggleModal = () => setModalOpen(!modalOpen)
  const handleImageClick = () => {
    const url = imagePath("idCard", userData?.id_card)
    setImageUrl(url)
    toggleModal()
  }
  const downloadClick = async event => {
    event.preventDefault()

    try {
      const response = await axios.get(
        `${API_URL}/admin/download-image/${userData?.id_card}`,
        {
          responseType: "blob",
        }
      )

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", id)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.error("Error downloading the file:", error)
    }
  }

  return (
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Security Details</CardTitle>

          <Form>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Date of Birth</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  14-02-1997
                </p>
              </Col>
            </div>

            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Secure Pin</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">*****</p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Can Bet Using</Label>
              </Col>
              <Col xs={6} sm={8} md={6} lg={6}>
                <Row>
                  <Col xs={6} sm={6} md={6} lg={6}>
                    <div className="form-check form-check-end">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="defaultCheck2"
                        defaultChecked
                      />
                      <label
                        className="form-check-label"
                        htmlFor="defaultCheck2"
                      >
                        SMS
                      </label>
                    </div>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6}>
                    <div className="form-check form-check-end">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="defaultCheck2"
                        defaultChecked
                      />
                      <label
                        className="form-check-label"
                        htmlFor="defaultCheck2"
                      >
                        Online
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} sm={6} md={6} lg={6}>
                    <div className="form-check form-check-end">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="defaultCheck2"
                        defaultChecked
                      />
                      <label
                        className="form-check-label"
                        htmlFor="defaultCheck2"
                      >
                        Retail
                      </label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Played</Label>
              </Col>
              <Col xs={6} sm={8} md={6} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {new Date(
                    Date.parse(props?.userData?.last_played)
                  ).toLocaleDateString("en-GB")}{" "}
                  {new Date(
                    Date.parse(props?.userData?.last_played)
                  ).toLocaleTimeString()}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Transaction</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {new Date(
                    Date.parse(props?.userData?.last_played)
                  ).toLocaleDateString("en-GB")}{" "}
                  {new Date(
                    Date.parse(props?.userData?.last_played)
                  ).toLocaleTimeString()}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Login</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {new Date(
                    Date.parse(props?.userData?.last_login)
                  ).toLocaleDateString("en-GB")}{" "}
                  {new Date(
                    Date.parse(props?.userData?.last_login)
                  ).toLocaleTimeString()}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">NRC Number</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props?.userData?.nrc_number}
                </p>
              </Col>
            </div>
            {hasPermission("read-idcard") && props?.userData?.id_card !== "" && (
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">ID Card</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    {hasPermission("view-idcard") && (
                      <a onClick={handleImageClick}>
                        <i className="mdi mdi-eye font-size-24"></i>
 
                      </a>
                    )}
                    {hasPermission("download-idcard") && (
                      <a  onClick={downloadClick}>
                        <i className="bx bx-download h2 m-0"></i>
                      </a>
                    )}
                  </div>
                </Col>
              </div>
            )}
            <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
              <ModalHeader toggle={toggleModal}>ID Card</ModalHeader>
              <ModalBody>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={imageUrl}
                    alt="ID Card"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </ModalBody>
            </Modal>
          </Form>
        </CardBody>
      </Card>
    </Col>
  )
}
